// global custom directive called `v-clear-input-on-change`
const clearInputOnChange = {
    bind(el, binding, vnode) {
        if ((!Object.prototype.hasOwnProperty.call(binding, 'value')) || binding.value) {
            vnode.componentInstance.$on('change', function() {
                this.$nextTick(() => {
                    vnode.componentInstance.lazySearch = null;
                });
            });
        }
    },
    unbind(el, binding, vnode) {
        vnode.componentInstance.$off('change');
    },
};

export default clearInputOnChange;
